import {UI} from "../../../stem-core/ui/UIBase";

import {styleRuleInherit} from "../../../stem-core/decorators/Style";
import {registerStyle} from "../../../stem-core/ui/style/Theme";
import {IndexExpanded} from "../pages/index-expanded/IndexExpanded";
import {WalletPopup, WalletPopupStyle} from "./WalletPopup";


class MerchantPopupStyle extends WalletPopupStyle {
    @styleRuleInherit
    popup = {
        background: this.themeProps.POPUP_BACKGROUND,
        boxShadow: this.themeProps.POPUP_SHADOW,
    };

    @styleRuleInherit
    visible = {
        borderRadius:  "4px 4px 0 0",
    };
}

export function MerchantPopup(CardClass) {
    @registerStyle(MerchantPopupStyle)
    class Popup extends WalletPopup(CardClass) {
        static getParentNode() {
            // TODO @cleanup this is an abomination, aha
            return IndexExpanded.instance.innerContainer.node;
        }
    }

    return Popup;
}
